import React from 'react';
import {  useNavigate } from 'react-router-dom';
import AuthLayout from '../Layouts/Authlayout';
import {
  RESET_PASSWORD_SUCCESS_TITLE,
  RESET_PASSWORD_SUCCESS_MESSAGE,
  RESET_PASSWORD_SUCCESS_BTN
} from '../../constants/constant';



export default function NewPasswordSuccess(): JSX.Element {
  
  
  const navigate = useNavigate();
 
  const handleClick = (): void => {
    navigate('/')
}
  return (
    <AuthLayout>
    <img
        src="/assets/images/success.svg"
        alt="logo"
        width={65}
        height={65}
        className="mx-auto mb-[20px]"
    />
    <h1 className="text-center text-[18px] font-bold text-muted mb-[15px]">
        {RESET_PASSWORD_SUCCESS_TITLE}
    </h1>
    <p className="text-subtitle text-center text-[14px] mb-[35px]">
        {RESET_PASSWORD_SUCCESS_MESSAGE}
    </p>
    <button
        onClick={handleClick}
        className="btn btn-block bg-gradient-to-b border-0 from-red to-primary h-[45px] text-14 normal-case hover:from-[#D6242C] hover:to-[#ED4B52]	focus-visible:outline-none rounded-50 font-semibold text-white"
    >
        {RESET_PASSWORD_SUCCESS_BTN}
    </button>
</AuthLayout>
  );
}
